const PROD_API_BASE = 'https://exhibit-api.chattermill.workers.dev';
const PROD_ARTIFACT_ORIGIN = 'https://exhibit-artifact.chattermill.workers.dev';

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || (isLocalhost ? '' : PROD_API_BASE);

export const ARTIFACT_ORIGIN =
  import.meta.env.VITE_ARTIFACT_ORIGIN || (isLocalhost ? '' : PROD_ARTIFACT_ORIGIN);

export const SLACK_CLIENT_ID =
  import.meta.env.VITE_SLACK_CLIENT_ID || '2518491775.10812277818070';
